<template>
  <div class="page-container content-430">
    <SearchBlock
      ref="searchBlockRef"
      @on-search="onSearch"
      @on-export="onExport"
    ></SearchBlock>
    <div class="table-main">
      <Table
        :columns="tableColumns"
        :data="tableData"
        border=""
        :loading="tableLoading"
        :max-height="tableHeight"
      >
        <template slot="isVisible" slot-scope="{ row, index }">
          <div @mouseenter="handleVisible(row, index)">
            <i-switch
              v-model="tableData[index]['isVisible']"
              :false-value="0"
              :true-value="1"
              @on-change="onVisibleChange"
            ></i-switch>
          </div>
        </template>

        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>

        <template slot="offerName" slot-scope="{ row }">
          <TablePoptip :content="row.offerName"> </TablePoptip>
        </template>

        <template slot="orgName" slot-scope="{ row }">
          <TablePoptip :content="row.orgName"> </TablePoptip>
        </template>
        <template slot="classroomName" slot-scope="{ row }">
          <TablePoptip :content="row.classroomName"> </TablePoptip>
        </template>
        <template slot="itemName" slot-scope="{ row }">
          <TablePoptip :content="row.itemName"> </TablePoptip>
        </template>
        <template slot="materialDisplayPrice" slot-scope="{ row }">
          <span>{{
            row.materialDisplayPrice
              ? (row.materialDisplayPrice / 100).toFixed(2)
              : ''
          }}</span>
        </template>
        <template slot="offerPrice" slot-scope="{ row }">
          <span>{{ (row.offerPrice / 100).toFixed(2) }}</span>
        </template>
        <template slot="classroomState" slot-scope="{ row }">
          <span v-if="row.classroomState == 0" class="color-red">下架</span>
          <span v-else class="color-blue">上架</span>
        </template>
        <template slot="action" slot-scope="{ row }">
          <span
            class="click-btn-430"
            style="margin-right: 5px"
            @click="handleToOrder(row)"
          >订单</span>
        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        show-sizer
        show-total
        show-elevator
        :page-size-opts="pageSizeOpts"
        :current="pageInfo.pageNum"
        class="page-right"
        @on-change="handlePageChange"
        @on-page-size-change="onPageSizeChange"
      ></Page>
    </div>
  </div>
</template>

<script>
import SearchBlock from './components/SearchBlock';
import { getTableColumns } from './components/data/index';
import courseCenterApi from '@/request/courseCenter/index.js';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
export default {
  name: 'CourseCenterCommodityMaterialTable',
  components: {
    SearchBlock
  },

  mixins: [mixinTableHeight],
  //
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('CourseCenterCommodityMaterialTable');
    next();
  },
  data() {
    return {
      tableColumns: getTableColumns(),
      tableData: [],
      tableLoading: false,
      pageSizeOpts: [10, 20, 50, 100], // 每页条数
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      selectRow: null,
      searchInfo: {},
      selectIndex: -1

    };
  },
  created() {

  },
  activated() {
    this.onSearch();
  },
  methods: {
    ...mapMutations([
      'SET_CACHEROUTE',
      'PUSH_CACHEROUTE',
      'DELETE_CACHEROUTE'
    ]),
    onSearch(info) {
      this.pageInfo.pageNum = 1;
      this.searchInfo = info;
      this.getCourseClassMaterialPage();
    },
    async onExport() {
      const parameter = this.getParameter();
      delete parameter.pageNum;
      delete parameter.pageSize;
      if (!this.checkParameter(parameter)) return null;
      this.$Spin.show();
      const res = await courseCenterApi.courseClassMaterialExport({
        ...parameter,
        pageSize: this.pageInfo.total,
        pageNum: 1
      });
      this.$Spin.hide();
      downLoadByBlob(res);
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getCourseClassMaterialPage();
    },
    onPageSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getCourseClassMaterialPage();
    },
    handleToOrder(row) {
      this.DELETE_CACHEROUTE(
        'orderMaterialIndex'
      );
      this.$router.push({
        name:
          'orderCenter_order_materialIndex',
        query: {
          materialId: row.materialId
        }
      });
    },
    handleVisible(row, index) {
      console.log(row);
      this.selectRow = row;
      this.selectIndex = index;
    },
    async onVisibleChange(val) {
      this.$nextTick(async() => {
        const res = await courseCenterApi.updateIsVisible({
          materialId: this.selectRow.materialId,
          isVisible: val
        });
        if (res.status == 200) {
        } else {
          this.tableData[this.selectIndex]['isVisible'] = val == 0 ? 1 : 0;
          this.tableData = Object.assign([], this.tableData);
        }
      });
    },

    getParameter() {
      const { pageNum, pageSize } = this.pageInfo;
      return {
        pageNum,
        pageSize,
        ...this.searchInfo
      };
    },
    checkParameter(parameter) {
      const reg = /^[0-9]{1,20}$/;
      const { materialId, classroomId } = parameter;
      if (materialId && !reg.exec(materialId)) {
        this.$Message.warning('请输入正确的材料ID');
        return false;
      }
      if (classroomId && !reg.exec(classroomId)) {
        this.$Message.warning('请输入正确的商品ID');
        return false;
      }
      return true;
    },
    // 获取列表
    async getCourseClassMaterialPage() {
      const parameter = this.getParameter();
      if (!this.checkParameter(parameter)) return null;
      this.tableLoading = true;
      const res = await courseCenterApi.getCourseClassMaterialPage(parameter);
      this.tableLoading = false;
      if (res.status == 200) {
        this.tableData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
